export const FILE_MAX_BYTES = 25 * 1024 * 1024;

export const AVATAR_MAX_BYTES = 512 * 1024;

export const AGENT_FILE_MAX_BYTES = 1024 * 1024;

export const AVATAR_EDGE = 256;

const RENDERABLE = new Set([
  "image/apng",
  "image/avif",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/webp",
  "audio/aac",
  "audio/mpeg",
  "audio/mp4",
  "audio/ogg",
  "audio/wav",
  "audio/webm",
  "video/mp4",
  "video/ogg",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "application/json",
  "text/plain",
  "text/csv",
  "text/markdown",
  "text/tab-separated-values",
]);

const BY_EXTENSION: Record<string, string> = {
  mov: "video/quicktime",
  m4a: "audio/mp4",
  aac: "audio/aac",
  md: "text/markdown",
  markdown: "text/markdown",
  csv: "text/csv",
  tsv: "text/tab-separated-values",
  json: "application/json",
  txt: "text/plain",
  log: "text/plain",
  ts: "text/plain",
  tsx: "text/plain",
  js: "text/plain",
  jsx: "text/plain",
  mjs: "text/plain",
  cjs: "text/plain",
  sql: "text/plain",
  sh: "text/plain",
  bash: "text/plain",
  py: "text/plain",
  rb: "text/plain",
  go: "text/plain",
  rs: "text/plain",
  css: "text/plain",
  yml: "text/plain",
  yaml: "text/plain",
  toml: "text/plain",
  ini: "text/plain",
  env: "text/plain",
};

export const FILE_KINDS = ["Image", "Video", "Audio", "Text", "Data", "Other"] as const;
export type FileKind = (typeof FILE_KINDS)[number];

export function kindOf(mediaType: string): FileKind {
  if (mediaType.startsWith("image/")) return "Image";
  if (mediaType.startsWith("video/")) return "Video";
  if (mediaType.startsWith("audio/")) return "Audio";
  if (isTable(mediaType)) return "Data";
  if (isText(mediaType)) return "Text";
  return "Other";
}

export function mediaTypeOf(claimed: string | undefined, name?: string): string {
  const bare = (claimed ?? "").split(";")[0]?.trim().toLowerCase() ?? "";
  if (RENDERABLE.has(bare)) return bare;
  const end = (name ?? "").toLowerCase().split(".").pop() ?? "";
  return BY_EXTENSION[end] ?? "application/octet-stream";
}

export function isImage(mediaType: string): boolean {
  return mediaType.startsWith("image/") && RENDERABLE.has(mediaType);
}

export function isTable(mediaType: string): boolean {
  return mediaType === "text/csv" || mediaType === "text/tab-separated-values";
}

export function isText(mediaType: string): boolean {
  return (mediaType.startsWith("text/") || mediaType === "application/json") && RENDERABLE.has(mediaType);
}

export function previewsFirst(mediaType: string): boolean {
  return isTable(mediaType) || mediaType === "text/markdown" || mediaType === "application/json";
}
